module.exports = __webpack_public_path__ + "media/media/distributors/person-4-7202fdcfac18a120e706fe072feeaca2.jpg";